/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useRef, createRef, useMemo } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import Image from 'next/image';
import map from 'lodash/map';

import { withTranslation } from 'language/i18n';
import VideoWithThumbnail from 'components/VideoWithThumbnail';

const DesktopSlider = ({
  setGalleryContent, medias, mediasGroupedByCategoryName,
}) => {
  const sliderRef = useRef();

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const filteredMediasGroupedByCategoryName = useMemo(() => {
    const newValue = { ...mediasGroupedByCategoryName };
    delete newValue.BAŞLARKEN;
    return newValue;
  }, [mediasGroupedByCategoryName]);

  const categoryRefs = Object.keys(filteredMediasGroupedByCategoryName).reduce((acc, value) => {
    acc[value] = createRef();
    return acc;
  }, {});

  const scrollToDesktopCategory = (id) => {
    categoryRefs[id].current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  const slideNext = () => {
    sliderRef.current.slickNext();
  };

  const slidePrevious = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className="im-box im-box--white im-box--border-radius im-box--list-item im-box--padding-sm-15 d-none d-lg-block">
      <div className="im-image-gallery im-product-gallery">
        <div className="im-image-gallery__view">
          <div className="im-slider-container product-detail-page-slider">
            <div className="im-slider im-image-gallery__view__slider product-gallery-slider">
              <Slider {...sliderSettings} ref={sliderRef}>
                {
                  medias.length > 0
                    ? map(medias, (media, index) => (
                      <div
                        onClick={() => setGalleryContent({ medias, showIndex: index })}
                        className="product-gallery-slider__item"
                        key={index}
                      >
                        {media.type === 'video' ? (
                          <VideoWithThumbnail
                            video={media}
                            width="640px"
                            height="480px"
                            notPlayable
                          />
                        ) : (
                          <Image
                            src={media.main}
                            width="640"
                            height="480"
                          />
                        )}
                      </div>
                    ))
                    : (
                      <div className="product-gallery-slider__item">
                        <Image
                          src="/image/machine-detail-slider-placeholder.jpg"
                          width="640"
                          height="480"
                        />
                      </div>
                    )
                }
              </Slider>
            </div>
            <div className="im-slider__arrows">
              <div className="im-slider__arrows__prev" onClick={() => slidePrevious()}>
                <i className="fa-solid fa-angle-left" />
              </div>
              <div className="im-slider__arrows__next" onClick={() => slideNext()}>
                <i className="fa-solid fa-angle-right" />
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4 d-none d-lg-flex">
          {
            map(Object.keys(filteredMediasGroupedByCategoryName), (categoryName, index) => (
              <div
                className="col-5 list-item-v"
                key={index}
                onClick={() => scrollToDesktopCategory(categoryName)}
              >
                <a className="fs-13 fw-700 hover-to-yellow">
                  {categoryName}
                </a>
              </div>
            ))
          }
        </div>
        <div className="im-image-gallery__nav d-none d-md-block">
          {map(filteredMediasGroupedByCategoryName, (categoryMedias, categoryName) => (
            <div className="row" ref={categoryRefs[categoryName]}>
              {categoryMedias.length > 0
                  && (
                    <div className="col-15 h5 fw-900 mb-3 mt-3">
                      {categoryName}
                    </div>
                  )}
              {map(categoryMedias, (media, index) => (
                <div className="col-3 mb-3 pl-2" key={index}>
                  <div
                    className="im-image-gallery__nav__item-grid"
                    key={index}
                  >
                    <a
                      onClick={() => setGalleryContent({
                        medias: categoryMedias,
                        showIndex: index,
                        title: categoryName,
                      })}
                      className="im-image-gallery__nav__item"
                      style={{ opacity: 1 }}
                    >
                      {media.type === 'video' ? (
                        <VideoWithThumbnail
                          video={media}
                          layout="fill"
                          objectFit="cover"
                          notPlayable
                          smallerPlayButton
                        />
                      ) : (
                        <Image
                          src={media.thumbnail}
                          layout="fill"
                          objectFit="cover"
                        />
                      )}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

DesktopSlider.propTypes = {
  setGalleryContent: PropTypes.func,
  medias: PropTypes.array,
  mediasGroupedByCategoryName: PropTypes.object,
};

export default withTranslation('common')(DesktopSlider);
